export default "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?0207b94ccbbd5be9a50b48277e12d47c";